export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Sirve para entrenadores que recién empiezan?',
    answer:
      'Sí. Tenis 360 te da la estructura profesional completa que ninguna certificación de entrenador termina de darte. Los entrenadores nuevos tienen un sistema completo desde el día uno.',
  },
  {
    question: '¿Qué niveles y edades cubre?',
    answer:
      'Todos los niveles: niños desde Sub-10 hasta avanzado, adultos y adolescentes en los tres niveles, más volúmenes especiales para jugadores senior y alumnos que vuelven de una lesión.',
  },
  {
    question: '¿Es un libro físico o un producto digital?',
    answer:
      'Tenis 360 es un producto digital entregado en archivos PDF, optimizados tanto para pantallas de móvil como para impresión en A4. Léelo en el celular al borde de la cancha o imprímelo en casa.',
  },
  {
    question: '¿Cómo recibo mi compra?',
    answer:
      'Inmediatamente después del pago recibes un email con tu enlace de descarga. El acceso es instantáneo: puedes estar usando el material en menos de 5 minutos.',
  },
  {
    question: '¿Y si no quedo satisfecho?',
    answer:
      'Estás totalmente cubierto por la garantía de devolución de 7 días. Solo envíanos un mensaje y te devolvemos el 100% de tu dinero. Sin preguntas ni formularios.',
  },
  {
    question: '¿Puedo usarlo en clases de escuela o academia?',
    answer:
      'Por supuesto. Cada volumen incluye adaptaciones grupales y el bono Kit de Supervivencia está diseñado específicamente para entornos grupales y escolares complejos.',
  },
  {
    question: '¿En qué se diferencia de los ejercicios gratuitos que hay en internet?',
    answer:
      'Los recursos gratuitos te dan ejercicios sueltos sin contexto ni progresión. Tenis 360 es un sistema completo de entrenamiento: cada ejercicio conecta con el siguiente, cada nivel se apoya en el anterior y cada sesión tiene un objetivo claro.',
  },
]
